import React from 'react';
import {FieldArray, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';

//import components
import AdvancedSearchFormFieldset from './AdvancedSearchFormFieldset.js';

//helper script
import validate from '../../scripts/AdvancedSearchFormValidation.js';

const AdvancedSearchForm = ({ data, handleSubmit, submitting, change, pristine, reset, clang, getRelation, conjOptions, getAllRelations }) => {
    return (
        <div className="advanced-search__form">
            <form onSubmit={handleSubmit}>
                <div className="advanced-search__content">
                    <FieldArray
                        name="searchQueries"
                        component={AdvancedSearchFormFieldset}
                        optionData={data}
                        change={change}
                        conjOptions={conjOptions}
                        getAllRelations={getAllRelations}
                        getRelation={getRelation}/>
                </div>
                <div className="advanced-search__form__actions">
                    <button type="button" disabled={pristine || submitting} onClick={reset} className="advanced-search__form__cancel" title={lang[clang].clean}>
                        {lang[clang].clean}
                    </button>
                    <button type="submit" disabled={submitting} className="advanced-search__form__submit" title={lang[clang].look_for}>
                        {lang[clang].look_for}
                    </button>
                </div>
            </form>
        </div>
    );
};

AdvancedSearchForm.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(reduxForm({
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
    destroyOnUnmount: false,
    validate,
})(AdvancedSearchForm));



// WEBPACK FOOTER //
// ./src/components/advanced-search/AdvancedSearchForm.js